<template>
  <n-chat-history ref="chatEl" class="inherit" v-if="messages.length" :data-list="messages" id-key="id">
    <template #default="{ data, index }">
      <div class="message" :class="data.role">
        <div class="message-content-loading flex-center" v-if="!data.content && data.loading">
          <n-loading-icon size="16" color="#999" />
        </div>
        <n-markdown class="message-content" v-else :value="data.content" @click.native="onMarkdownClick" />
        <div class="message-tools" :class="{hidden: !data.id && !data.isError}">
          <n-icon scene="gray" type="copy" title="复制" @click="onCopy(data.content)" />
          <!--  Chat 消息，type=1   -->
          <template v-if="data.role === 'human'">
            <n-icon scene="gray" type="refresh" title="重试" @click="onRetry(data, index)" />
          </template>
          <!--  help 消息，type=20   -->
          <template v-else-if="data.role === 'question'">
            <n-icon scene="gray" type="delete" title="删除" @click="onDelete(data, index)" />
          </template>
          <template v-if="data.role === 'ai' && !data.isError">
            <n-icon scene="gray" type="likes" title="点赞" :active="data.evaluate === 100"
                    @click="setEvaluate(data, 100)" />
            <n-icon scene="gray" type="unlikes" title="踩" :active="data.evaluate === 10"
                    @click="setEvaluate(data, 10)" />
          </template>
        </div>
      </div>
    </template>
  </n-chat-history>
</template>

<script>
import request from './request'

export default {
  name: 'chat-client-message',
  props: {
    room_id: tools.prop.stringNumber(),
    messages: tools.prop.array()
  },
  methods: {
    onCopy (content) {
      tools.copy(content)
    },
    // 评价
    setEvaluate (message, value) {
      const body = { message_id: message.id, value }
      this.$set(message, 'evaluate', value)
      request('/api/chat/evaluate', body)
    },

    // 重试
    async onRetry (message, index) {
      const messages = this.messages.slice(index)
      tools.spliceBy(this.messages, (v, i) => i < index)
      const message_ids = messages.map(message => message.id).filter(Boolean)
      if (message_ids.length) {
        await request('/api/chat/delete_message', { message_ids })
      }
      this.$emit('send-retry-message', message)
    },
    // 删除
    onDelete (message, index) {
      this.messages.splice(index, 1)
      request('/api/chat/delete_message', { message_ids: [message.id] })
    },
    onMarkdownClick (e) {
      if (e.target && e.target.tagName === 'A') {
        const text = e.target.innerText
        const url = e.target.getAttribute('href')
        request('/api/chat/on_link_click', { room_id: this.room_id, text, url }, { silence: true })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.message {
  margin: 12px 16px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 85%;

  &-content {
    font-size: 13px;
    border-radius: 8px;
    max-width: 100%;
    background-color: rgba(0, 0, 0, 0.05);
    padding: 8px 12px;
    user-select: text;
    word-break: break-word;
    border: 1px solid #dedede;
    position: relative;
    min-height: 38px;
  }

  &-content-loading {
    border-radius: 10px;
    border: 1px solid #dedede;
    background-color: rgba(0, 0, 0, 0.05);
    width: 38px;
    height: 38px;
  }

  &-tools {
    margin-top: 4px;

    &.hidden {
      visibility: hidden;
    }

    .n-icon {
      border-radius: 4px;
      border: 1px solid #dedede;
      font-size: 14px;
      width: 22px;
      line-height: 20px;
    }

    .ni-copy {
      font-size: 12px;
    }

    .n-icon + .n-icon {
      margin-left: 4px;
    }
  }

  &:first-child {
    margin-top: 16px;
  }

  &:last-child {
    margin-bottom: 16px;
  }

  &.help .message-content {
    background-color: #f1fff1;
  }

  &.human,
  &.question {
    margin-left: auto;
    align-items: flex-end;

    .message-content {
      background-color: #e7f8ff;
    }
  }

  &.ai .message-content {
    padding-top: 16px;
    padding-bottom: 16px;
  }
}
::v-deep(.n-markdown) {
  table {
    font-size: 12px;
  }

  .mpn-matcher {
    text-align: center;
    color: #808080;
    font-size: 12px;

    i {
      margin: 3px;
      color: #EE2E14;
      font-style: normal;
    }

    mark {
      color: #808080;
      background-color: transparent;
    }
  }
}
</style>
